// extracted by mini-css-extract-plugin
export default {"unsub_container":"Menu_unsub_container__d1sbE","unsub_btn":"Menu_unsub_btn__renMq"};